import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Col } from "react-bootstrap";
import { fr } from "date-fns/locale";

registerLocale("fr", fr);

function DeliveryDatePicker({ selectedDate, onDateChange, availableDates = [] }) {
  // Convert available dates to Date objects for comparison (normalize to date only, ignoring time)
  const availableDateSet = new Set(
    availableDates.map(date => {
      const d = new Date(date);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate()).toDateString();
    })
  );

  // Filter function to enable only dates with deliveries
  const filterDate = (date) => {
    const normalizedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate()).toDateString();
    return availableDateSet.size === 0 || availableDateSet.has(normalizedDate);
  };

  return (
    <Col xs="auto">
      <div className="p-2 mb-2">
        <DatePicker
          selected={selectedDate}
          onChange={onDateChange}
          dateFormat="dd/MM/yyyy"
          placeholderText="Date de livraison"
          isClearable
          className="form-control"
          filterDate={filterDate}
          locale="fr"
        />
      </div>
    </Col>
  );
}

export default DeliveryDatePicker;
